import AutoInsurance from "resources/AutoInsurance.svg";
import BuildInsurance from "resources/BuildInsurance.svg";
import HealthInsurance from "resources/HealthInsurance.svg";
import TurInsurance from "resources/TurInsurance.svg";
import styles from "../Interactive.module.scss";

export const icons = {
  auto: AutoInsurance,
  build: BuildInsurance,
  health: HealthInsurance,
  tourism: TurInsurance,
};

export const Badge = ({
  icon,
  name,
  totalSteps,
  step,
  subtitle: state,
  onClick,
}: {
  icon: string;
  name: string;
  totalSteps?: number;
  step?: number;
  subtitle?: string;
  onClick?: () => void;
}) => (
  <div className={styles.badge} onClick={onClick}>
    <div className={styles.top}>
      <div className={styles.icon}>
        <img src={icons[icon as keyof typeof icons] ?? icon} alt="Product icon" />
      </div>
      <div className={styles.text}>
        <div className={styles.title}>{name}</div>
        {state && <div className={styles.subtitle}>{state}</div>}
      </div>
      {step && (
        <div className={styles.steps}>
          Шаг {step}/{totalSteps}
        </div>
      )}
    </div>
  </div>
);
